module.exports = "<img style=\"width: 90%; margin-top: 3%;\" src=\"../../../assets/estilosAdmin/fotos/fondo1.jpg\" />\n"